const form3 = {
  formId3: "new-user-form-3",
  formField3: {
    startDate: {
      name: "startDate",
      label: "[01] Kỳ tính thuế: Từ ngày",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày",
    },
    endDate: {
      name: "endDate",
      label: "Đến ngày",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    airlinesName: {
      name: "airlinesName",
      label: "[04] Tên hãng hàng không nước ngoài:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên hãng hàng không nước ngoài",
    },
    countryName: {
      name: "countryName",
      label: "[05] Nước cư trú:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn nước cư trú",
    },

    
    vehicleName: {
      name: "vehicleName",
      label: "[06] Tên/ hô hiệu phương tiện vận tải:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên/ hô hiệu phương tiện vận tải",
    },
    agencyName: {
      name: "agencyName",
      label: "[07] Tên văn phòng/ đại lý bán vé tại Việt Nam:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên văn phòng/ đại lý bán vé tại Việt Nam",
    },

    agencyId: {
      name: "agencyId",
      label: "[08] Mã số thuế nộp thay của bên Việt Nam:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế nộp thay của bên Việt Nam",
      invalidMsg: "Mã số thuế không hợp lệ",
    },

    taxAgencyName: {
      name: "taxAgencyName",
      label: "[09] Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[10] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },



    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form3;
